import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { TrendingUp, Users, DollarSign } from "lucide-react";
import noteInvestingImage from "@/assets/note-investing-process.jpg";

const NoteInvestingHero = () => {
  return (
    <section className="py-20 px-4 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Discover Real Estate's Best Kept Secret
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Learn how smart investors buy land contracts and private mortgages at a discount 
            to create superior yields while helping property sellers get immediate cash.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img 
              src={noteInvestingImage} 
              alt="Note investing process illustration" 
              className="rounded-lg shadow-xl w-full"
            />
          </div>
          
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-gray-900">
              The 3-Step Note Investing Process
            </h2>
            
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">
                  1
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Original Contract Created</h3>
                  <p className="text-gray-600">John sells his $200,000 house to Mary: $40,000 down, $160,000 financed at 7% for 15 years</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="bg-yellow-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">
                  2
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Seller Needs Immediate Cash</h3>
                  <p className="text-gray-600">John needs $120,000 for a business opportunity and sells his note to you for $135,000</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="bg-green-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">
                  3
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Investor Manages & Collects</h3>
                  <p className="text-gray-600">You receive $1,438/month, verify insurance/taxes annually, and earn 12.8% returns</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="bg-purple-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">
                  4
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Ongoing Asset Protection</h3>
                  <p className="text-gray-600">Monitor property insurance, tax payments, and maintain payment history records</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <Card className="p-6 text-center">
            <TrendingUp className="h-12 w-12 text-blue-600 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Higher Yields</h3>
            <p className="text-gray-600">
              Buying at a discount increases your effective yield compared to traditional investments
            </p>
          </Card>
          
          <Card className="p-6 text-center">
            <Users className="h-12 w-12 text-yellow-600 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Win-Win Solution</h3>
            <p className="text-gray-600">
              Sellers get immediate cash, investors get superior returns on secured real estate
            </p>
          </Card>
          
          <Card className="p-6 text-center">
            <DollarSign className="h-12 w-12 text-green-600 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Asset-Backed Security</h3>
            <p className="text-gray-600">
              Every investment is secured by real estate collateral, not just a promise to pay
            </p>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default NoteInvestingHero;